var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-property-type-add'},"title":_vm.$t('setting.property.property-type.text')}}),_c('List',{attrs:{"dataList":_vm.typeList,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[],"fields":[ 
          ("name: " + (_vm.$t('setting.property.property-type.name')))
        ],"deletes":[_vm.deleted, null],"edit":{link: 'setting-property-type-edit'},"filter":{
          search: ['property_types.name'],
          dropdown: []
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }